// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Aob","up":"e_Bob","down":"e_Cob","percent":"e_Dob","percentVal":"e_Eob","title":"e_Fob","tags":"e_Gob","textBadge":"e_Hob"};